const styles = theme => ({
  bannerText: {
    margin: '0.6rem 0rem',
  },
  solidctastyle: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    width: '9.65rem',
    padding: '0.3125rem',
    marginLeft: '2rem',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    height: '1.87rem',

    color: theme.palette.secondary.contrastText,
    background: theme.palette.primary.buttonColor,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 4px 45px -9px ${theme.palette.primary.boxShadow1Darkest}`,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '0.5rem',
    },
  },
  ctastyle: {
    border: `0.1875rem solid ${theme.palette.primary.buttonColor}`,
    width: '9.65rem',
    padding: '0.3125rem',
    marginLeft: '2rem',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',

    height: '1.87rem',
    color: theme.palette.primary.buttonColor,

    '&:hover': {
      background: theme.palette.primary.buttonColor,
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '0.5rem',
    },
  },
});
export default styles;
